import { render, staticRenderFns } from "./ThirdLogin.vue?vue&type=template&id=0b72ad24&scoped=true&"
import script from "./ThirdLogin.vue?vue&type=script&lang=js&"
export * from "./ThirdLogin.vue?vue&type=script&lang=js&"
import style0 from "./ThirdLogin.vue?vue&type=style&index=0&id=0b72ad24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72ad24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b72ad24')) {
      api.createRecord('0b72ad24', component.options)
    } else {
      api.reload('0b72ad24', component.options)
    }
    module.hot.accept("./ThirdLogin.vue?vue&type=template&id=0b72ad24&scoped=true&", function () {
      api.rerender('0b72ad24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/third/ThirdLogin.vue"
export default component.exports